import { forwardRef, type ReactNode } from 'react';
import { Link, type LinkProps } from 'react-router-dom';
import { cn } from '@/shared/lib/cn';

export type TextLinkProps = Omit<LinkProps, 'children'> & {
  children: ReactNode;
};

export const TextLink = forwardRef<HTMLAnchorElement, TextLinkProps>(
  ({ className, children, ...props }, ref) => (
    <Link
      ref={ref}
      className={cn(
        'inline-flex items-center gap-1.5 text-sm font-semibold text-gray-700 no-underline transition-colors duration-150',
        'hover:text-gray-900 hover:no-underline',
        'focus-visible:rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-900 focus-visible:ring-offset-2',
        className,
      )}
      {...props}
    >
      {children}
    </Link>
  ),
);
TextLink.displayName = 'TextLink';
